# ARCHITECTURE NOTE - Assumes the store is accessible at "window.reduxStore"
accesStoreMiddleware = ->
  (next) ->
    (action) -> next( $.extend({}, action, getState: window.reduxStore.getState) )

export default accesStoreMiddleware
